/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"8\"><path fill=\"#20455E\" d=\"M11.854 7A4 4 0 1115 7.97V8H4v-.03A4 4 0 117.146 7h4.708zM14.5 7a3 3 0 100-6 3 3 0 000 6zm-10 0a3 3 0 100-6 3 3 0 000 6z\"/></svg>\n";
//# sourceMappingURL=voicemail.svg.js.map